import { ValidateContact, ValidateText } from "@/util/ValidationUtil";

export class InspectorReqDto {
    /**
     * 점검 사용자 uuid
     * */
    userUuid: string;
    /**
     * 점검 사용자 ID
     * */
    @ValidateText("아이디")
    userId: string;
    /**
     * 점검 사용자 이름
     * */
    @ValidateText("성명")
    firstName: string;
    /**
     * 점검 사용자 비밀번호
     */
    @ValidateText("비밀번호", obj => !obj.userUuid)
    password: string;
    /**
     * 점검 사용자 소속
     * */
    @ValidateText("소속")
    companyName: string;
    /**
     * 점검 사용자 핸드폰 번호
     * */
    @ValidateContact("핸드폰 번호")
    phone: string;
    /**
     * 점검 사용자 권한
     * */
    role: string;
    /**크
     * 가입 날짜
     * */
    createdAt: string;
}